module.exports = __webpack_public_path__ + "img/industry-img5.dbca0477.png";